import type { ReactNode } from 'react';
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import type { ThemeDto } from '../api/themes.api';
import { ThemeEditorContext } from './ThemeEditorContext';

export const ThemeEditorProvider = ({ children }: { children: ReactNode }) => {
  const [themeOverrides, setThemeOverrides] = useState<Record<string, ThemeDto>>({});
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('clientId');

  const [prevClientId, setPrevClientId] = useState(clientId);
  if (clientId !== prevClientId) {
    setPrevClientId(clientId);
    setThemeOverrides({});
  }

  return (
    <ThemeEditorContext.Provider value={{ themeOverrides, setThemeOverrides }}>{children}</ThemeEditorContext.Provider>
  );
};
